import React, { Component } from 'react'
import { connect } from 'react-redux'

import { actualizarDatosParaMuiTable } from '../actions/TablaDistribucionEspacioPorCerealActions'
import { TablaDistribucionEspacioPorCerealView } from '../components/TablaDistribucionEspacioPorCerealView'

class TablaDistribucionEspacioPorCereal extends Component {
  componentDidMount () {
    this.props.actualizarDatosParaMuiTable(this.props.conLink)
  }

  render () {
    return <TablaDistribucionEspacioPorCerealView />
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)

export default withRedux(TablaDistribucionEspacioPorCereal)
